export const environment = {
  production: false,
  url: "https://api-motor-3.policystreet.app",
  googleTagId: "",
  cleverTapId: "TEST-ZK9-6ZK-696Z",
};
